import { createFileRoute, useParams } from "@tanstack/react-router";
import { createJobAttachmentsListQueryOptions } from "@/features/attachments/adapters/job-attachments-adapter";
import { JobAttachmentsWorkspace } from "@/features/attachments/components/job-attachments-workspace";
import { ATTACHMENTS_FILES_PAGE_SIZE } from "@/features/attachments/types";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/attachments",
)({
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			createJobAttachmentsListQueryOptions({
				jobId: params.jobId,
				organizationId: params.orgId,
				start: 1,
				count: ATTACHMENTS_FILES_PAGE_SIZE,
			}),
		),
	component: JobWorkspaceAttachmentsTab,
});

/**
 * Job workspace Attachments tab — thin route adapter.
 */
function JobWorkspaceAttachmentsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/attachments",
	});

	return <JobAttachmentsWorkspace orgId={params.orgId} jobId={params.jobId} />;
}
